export type EventListener<Payload> = (payload: Payload) => void;

export class TypedEventEmitter<Events extends object> {
  private readonly listeners = new Map<keyof Events, Set<EventListener<Events[keyof Events]>>>();

  on<Type extends keyof Events>(type: Type, listener: EventListener<Events[Type]>): () => void {
    const listeners = this.listeners.get(type) ?? new Set<EventListener<Events[keyof Events]>>();
    listeners.add(listener as EventListener<Events[keyof Events]>);
    this.listeners.set(type, listeners);
    return () => {
      listeners.delete(listener as EventListener<Events[keyof Events]>);
    };
  }

  protected emit<Type extends keyof Events>(type: Type, payload: Events[Type]): void {
    for (const listener of this.listeners.get(type) ?? []) {
      listener(payload);
    }
  }

  protected clearListeners(): void {
    this.listeners.clear();
  }
}
